import React, {useEffect, useState} from "react";
import {Button, Col, DatePicker, Form, Image, Input, message, Row, Tabs, TabsProps, Upload, UploadProps} from "antd";
import {useStore} from "../../store";
import {forEach} from "lodash";
import moment from "moment";
import {showFullScreenLoading, tryHideFullScreenLoading} from "../../config/serviceLoading";
import {addSpecimenInfoApi, editSpecimenInfoApi, uploadSpecimenPictureApi} from "../../http/manager";
import {observer} from "mobx-react";
import styled from "styled-components";
import {UploadOutlined} from "@ant-design/icons";
import {BaseImageUrl} from "../../http/http";
import {ManagerBusinessType} from "../../common/Constant";

interface SpecimenProps {
    onSuccess: ()=> void;
}

const defaultIcon = require("../../image/default-pic.png")

const Specimen:React.FC<SpecimenProps> = ({onSuccess}) => {

    const [form] = Form.useForm();
    const [type, setType] = useState("1")

    const {specimenStore} = useStore();
    useEffect(() => {
        if (specimenStore.detailType === "edit") {
            const {showBaseLibraryDetail} = specimenStore;
            const detail = JSON.parse(JSON.stringify(showBaseLibraryDetail));
            if (detail && detail.authenticateDate) {
                detail.authenticateDate = moment(detail.authenticateDate)
            }
            if (detail && detail.gatherDate) {
                detail.gatherDate = moment(detail.gatherDate)
            }
            if (detail && detail.entryDate) {
                detail.entryDate = moment(detail.entryDate)
            }
            form.setFieldsValue(detail);
        }
        specimenStore.setSrcFile(null)
        specimenStore.clearFileList();
        // return form.resetFields();
    }, []);

    const tabItems:TabsProps['items'] = [
        {
            key: "1",
            label: "标本信息",
        },
        {
            key: "2",
            label: "物种信息",
        },
        {
            key: "3",
            label: "鉴定信息",
        },
    ];

    const props: UploadProps = {
        onRemove: (file) => {
        },
        beforeUpload: (file) => {
            specimenStore.setFilelist(file);
            fileToBase(file);
            return false;
        },
    };

    const fileToBase = (file:any) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => {
            const src = reader.result;
            specimenStore.setSrcFile(src);
        }
    }


    const specimenForm = () => {
        return <Form  form={form} layout={"vertical"} size={"middle"} style={{maxHeight: "400px", overflowY: "auto", overflowX:"hidden"}}>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label={"馆代码:"} name={"libraryCode"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"流水号:"} name={"serialNumber"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"条形码:"} name={"barCode"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"模式类型:"} name={"patternType"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"库存:"} name={"inventory"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"标本状态:"} name={"specimenStatu"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"采集人:"} name={"gatherer"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"采集号:"} name={"gatherNumber"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"采集日期:"} required={true}><DatePicker/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"国家:"} name={"country"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"省市:"} name={"province"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"区县:"} name={"district"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"海拔:"} name={"altitude"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"负海拔:"} name={"negativeAltitud"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"图片地址:"} name={"imgUrl"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Upload style={{marginTop:"15px" , marginBottom: "15px"}} showUploadList={false} name={"picture"} maxCount={1} listType="picture-card" {...props} >
                        {(specimenStore.showBaseLibraryDetail?.imgUrl || specimenStore.srcFile )? <Image preview={false} src={specimenStore.srcFile ? specimenStore.srcFile : BaseImageUrl+specimenStore.showBaseLibraryDetail?.imgUrl} fallback={defaultIcon}/> : <UploadOutlined/>}
                    </Upload>
                </Col>
            </Row>
        </Form>
    }

    const speciesForm = () => {
        return <Form form={form} layout={"vertical"} size={"middle"} style={{maxHeight: "400px", overflowY: "auto", overflowX:"hidden"}}>
            <Row gutter={24}>
                <Col span={8}>
                    <Form.Item label={"科:"} name={"specimenFamily"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"属:"} name={"specimenGenus"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"种:"} name={"specimenSpecies"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"定名人:"} name={"nominator"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"种下等级:"} name={"plantingGrade"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"中文名:"} name={"specimenName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"习性:"} name={"habit"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"体高:"} name={"bodyHeight"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"胸径:"} name={"dbh"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"茎:"} name={"stems"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"叶:"} name={"leaf"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"花:"} name={"flowers"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"果实:"} name={"fruit"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"寄主:"} name={"host"} required={true}><Input/></Form.Item>
                </Col>
            </Row>
        </Form>

    }

    const identificationForm = () => {
        return <Form form={form} layout={"vertical"} size={"middle"} style={{maxHeight: "400px", overflowY: "auto", overflowX:"hidden"}}>
            <Row  gutter={[15, 15]}>
                <Col span={8}>
                    <Form.Item label={"鉴定人:"} name={"authenticateEr"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"鉴定日期:"} name={"authenticateDate"} required={true}><DatePicker/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"备注:"} name={"remarks"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"地名:"} name={"placeName"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"生境:"} name={"habitat"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"经度:"} name={"lon"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"纬度:"} name={"lat"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"备注2:"} name={"remark2"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"录入员:"} name={"entryClerk"} required={true}><Input/></Form.Item>
                </Col>
                <Col span={8}>
                    <Form.Item label={"录入日期:"} name={"entryDate"} required={true}><DatePicker/></Form.Item>
                </Col>
            </Row>
        </Form>

    }

    const onTabChange = (key: string) => {
        setType(key);
    }

    const submit = () => {
        const formFields = form.getFieldsValue(true);
        const formKeys = Object.keys(formFields);
        if (specimenStore.detailType === "add" && specimenStore.fileList.length <= 0) {
            message.error("请选择照片");
            return;
        }
        form.validateFields(formKeys)
            .then((values) => {
                const formData = new FormData();
                forEach(formKeys, (key) => {
                    if (key === "authenticateDate" || key === "entryDate" || key === "gatherDate") {
                        formData.append(key, moment(formFields[key]).format("YYYY-MM-DD"))
                    } else {
                        formData.append(key, formFields[key]);
                    }
                })
                showFullScreenLoading()

                if (specimenStore.detailType === "add") {
                    addSpecimenInfoApi(formData)
                        .then((res) => {
                            if (Number(res.code) === 200) {
                                uploadPicture(res.data);
                            } else {
                                tryHideFullScreenLoading();
                                message.error("新增失败");
                            }
                        }).catch(() => {
                        message.error("新增失败");
                        tryHideFullScreenLoading()
                    })
                } else {
                    editSpecimenInfoApi(formData)
                        .then((res) => {
                            if (Number(res.code) === 200) {
                                if (specimenStore.fileList.length <= 0) {
                                    message.success("编辑成功");
                                    tryHideFullScreenLoading()
                                    onSuccess();
                                } else {
                                    uploadPicture(res.data, false);
                                }
                            } else {
                                tryHideFullScreenLoading();
                                message.error("编辑失败");
                            }
                        }).catch(() => {
                        message.error("编辑失败");
                        tryHideFullScreenLoading()
                    })
                }
            })
            .catch();
    }

    const uploadPicture = (data:any, isAdd = true) => {
        const params = new FormData();
        if (specimenStore.detailType === "edit") {
            params.append("id", String(specimenStore.showBaseLibraryDetail!.id));
        } else {
            params.append("id", data.id);
        }
        params.append("file", specimenStore.fileList[0]);
        params.append("type", ManagerBusinessType.SPECIMEN+"")
        uploadSpecimenPictureApi(params)
            .then((res) => {
                tryHideFullScreenLoading()
                if (Number(res.code) === 200) {
                    message.success(isAdd? "新增成功" : "编辑成功");
                    onSuccess();
                } else {
                    message.error(isAdd? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
                }
            }).catch(() => {
            message.error(isAdd? "新增失败, 图片上传失败" : "编辑失败, 图片上传失败");
            tryHideFullScreenLoading()
        })
    }

    return (<Wrapper>
        <Tabs items={tabItems} onChange={onTabChange}/>
        <div style={{paddingBottom:"16px"}}>
            {Number(type) === 1 && specimenForm()}
            {Number(type) === 2 && speciesForm()}
            {Number(type) === 3 && identificationForm()}
        </div>
        <Button onClick={submit} type={"primary"} style={{width: "70px", left: "630px"}}>提交</Button>
    </Wrapper>);
}

export default observer(Specimen);

const Wrapper = styled.div`
    & {
      display: flex;
      flex-direction: column;
      .ant-picker{
        width: 100%;
      }
    }
`;